import React, { useEffect, useState } from 'react';
import { getUser, getProgress } from '../data/db';
import {
  XPBar,
  Badge as LibBadge,
  Icon,
  FeatureIcon,
  StatCard,
  Card,
  ButtonPrimary
} from '../components/ComponentLibrary';
import { Trophy, Star, Target, Award, CheckCircle2 } from 'lucide-react';
import './ProgressNew.css';

export default function Progress() {
  const [user] = useState(getUser());
  const [progress, setProgress] = useState(getProgress(user.id));

  function levelFromPoints(p) {
    if (p < 50) return { level: 1, next: 50 };
    if (p < 150) return { level: 2, next: 150 };
    return { level: 3, next: 300 };
  }

  const lvl = levelFromPoints(user.points || 0);
  const pct = Math.min(100, Math.round(((user.points || 0) / lvl.next) * 100));

  useEffect(() => {
    setProgress(getProgress(user.id));
  }, [user.id]);

  return (
    <div className="progress-page">
      <header className="progress-header">
        <div className="progress-welcome">
          <div className="user-avatar-large">
            <Icon name="user" size={40} />
          </div>
          <div>
            <h1 className="progress-title">مركز الإنجازات <Icon name="progress" size={32} /></h1>
            <p className="progress-subtitle">مرحباً {user.name}، شاهد تقدمك وتفوقك!</p>
          </div>
        </div>
      </header>

      <div className="progress-stats-row">
        <StatCard
          title="المستوى الحالي"
          value={lvl.level}
          icon="progress"
          variant="sunshine"
          description={`المستوى القادم عند ${lvl.next} نقطة`}
        />
        <StatCard
          title="إجمالي النقاط"
          value={user.points || 0}
          icon="star"
          variant="sky"
          trend="+12 هذا الأسبوع"
          trendDirection="up"
        />
        <StatCard
          title="الدروس المكتملة"
          value={progress.filter(p => p.completed).length}
          icon="check"
          variant="success"
        />
      </div>

      <section className="level-progress-section">
        <Card className="level-card-main">
          <div className="level-header">
            <h3>التقدم للمستوى القادم</h3>
            <span className="pct-label">{pct}%</span>
          </div>
          <XPBar currentXP={user.points || 0} nextLevelXP={lvl.next} level={lvl.level} />
          <p className="xp-hint">تبقت لك {(lvl.next - (user.points || 0))} نقطة للوصول للمستوى التالي!</p>
        </Card>
      </section>

      <div className="progress-details-grid">
        {/* Badges Section */}
        <Card className="badges-card">
          <div className="section-title-wrapper">
            <Award size={24} className="title-icon" />
            <h3>شاراتي وأوسمتي</h3>
          </div>
          <div className="badges-list">
            {(user.badges || []).length > 0 ? (
              (user.badges || []).map(b => (
                <div key={b} className="badge-item">
                  <div className="badge-icon-bubble">
                    <Icon name="achievement" size={24} />
                  </div>
                  <span className="badge-name">{b}</span>
                </div>
              ))
            ) : (
              <p className="empty-msg">لم تحصل على شارات بعد. ابدأ التعلم لتحصل على أول شارة!</p>
            )}
          </div>
        </Card>

        {/* Completed Lessons Section */}
        <Card className="lessons-summary-card">
          <div className="section-title-wrapper">
            <CheckCircle2 size={24} className="title-icon" />
            <h3>الدروس المكتملة</h3>
          </div>
          <div className="completed-lessons-list">
            {progress.filter(p => p.completed).length > 0 ? (
              progress.filter(p => p.completed).map(p => (
                <div key={p.lessonId} className="completed-lesson-item">
                  <div className="lesson-info">
                    <span className="lesson-id-tag">#{p.lessonId}</span>
                    <span className="lesson-score-result">الدرجة: {p.score}%</span>
                  </div>
                  <LibBadge variant="success">مكتمل <Icon name="check" size={12} /></LibBadge>
                </div>
              ))
            ) : (
              <p className="empty-msg">لم تكمل أي دروس بعد. ابدأ رحلتك الآن!</p>
            )}
          </div>
          <ButtonPrimary className="mt-6 w-full" onClick={() => (window.location.href = '/lessons')}>
            اذهب للدروس <Icon name="lessons" size={20} />
          </ButtonPrimary>
        </Card>
      </div>
    </div>
  );
}
